/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Updates_Updateerror1Inputs */

const tr_updates_updateerror1 = /** @type {(inputs: Updates_Updateerror1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hata: ${i?.error}`)
};

const en_updates_updateerror1 = /** @type {(inputs: Updates_Updateerror1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error: {error}" |
*
* @param {Updates_Updateerror1Inputs} inputs
* @param {{ locale?: "tr" | "en" }} options
* @returns {LocalizedString}
*/
const updates_updateerror1 = /** @type {((inputs: Updates_Updateerror1Inputs, options?: { locale?: "tr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updates_Updateerror1Inputs, { locale?: "tr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "tr") return tr_updates_updateerror1(inputs)
	return en_updates_updateerror1(inputs)
});
export { updates_updateerror1 as "updates_updateError" }